import { useCallback } from "react"
import { createValidator } from "../../utils/validation";
import {
    ManagerSchema,
    ManagerIndividualSchema
 } from "../validationRules/validateManagementStructure";
import { useValidateUBOForm } from "./useValidateUBOForm";
import { isSectionSkipped } from "../../utils/navigationHelper";

export const useValidateManagementStructure = () => {

    const { validateUBOForm } = useValidateUBOForm();

    const validateManagementStructure = useCallback((formData)=>{

        // Skip only when the section genuinely does not apply — see the corporate hook.
        if (isSectionSkipped("management")) return {};

        console.log("Management Form Data", formData);

        let customValidator = { ...ManagerSchema };

        let errors = createValidator(customValidator)(formData);
        let anotherErrors = {};

        if (formData.managerEntity === "Individual") {
            customValidator = { ...ManagerIndividualSchema };
            anotherErrors = createValidator(customValidator)(formData.data);
        } else if (formData.managerEntity === "Corporate") {
            anotherErrors = validateUBOForm(formData.data.uboState ? formData.data.uboState : {});
        }

        errors = {...errors, ...anotherErrors};
        return errors;

    },[validateUBOForm]);

    return { validateManagementStructure };

}